import { PROFESSION_LABELS } from '@/lib/professions';
import type { Profession } from '@/types/onboarding';

export interface SpeakerTitles {
  clinician: string;
  counterpart: string;
}

export const DEFAULT_SPEAKER_TITLES: SpeakerTitles = { clinician: 'Læknir', counterpart: 'Sjúklingur' };

type NamedProfession = Exclude<Profession, 'other'>;

// Professions whose counterpart is a client, not a patient.
const CLIENT_PROFESSIONS = new Set<NamedProfession>([
  'social_worker',
  'dietitian',
  'psychologist',
  'occupational_therapist',
  'speech_therapist',
]);

const isNamedProfession = (label: string): label is NamedProfession =>
  label !== 'other' && Object.hasOwn(PROFESSION_LABELS, label);

/** Speaker names for the conversation view, from the user's auth labels (profession labels). */
export const getSpeakerTitles = (labels: string[] | undefined): SpeakerTitles => {
  const profession = labels?.find(isNamedProfession);
  if (!profession) return DEFAULT_SPEAKER_TITLES;
  return {
    clinician: PROFESSION_LABELS[profession],
    counterpart: CLIENT_PROFESSIONS.has(profession) ? 'Skjólstæðingur' : 'Sjúklingur',
  };
};
